import {
  antioxidantsBottle,
  fullSpectrumBottle,
  immuneFactorsBottle,
  nacBottle,
  berberineBottle,
  vitaminBComplexBottle,
  redYeastRiceBottle,
  vesselProtectionBottle,
  vitaminD3K25000Bottle,
  vitaminD3K22000Bottle,
  thinkfactorOverviewBackground,
  antioxidantOverviewBackground,
  immuneOverviewBottle,
  fullSpectrumOverviewBackground,
  immuneOverviewBackground,
  nAcetyleOverviewBackground,
  berberineOverviewBackground,
  vitBOverviewBackground,
  redYeastOverviewBackground,
  vesselProtectOverviewBackground,
  vitDK2OverviewBackground,
  vitDK5OverviewBackground,
} from '../../src/images';
import {
  LIGHTING_BOLT,
  CARDIAC_DARK,
  GROUP_FOCUS_DARK,
  VECTOR_IMMUNE_DARK,
} from '../../src/assets/images';

export const content = {
  TNK: {
    title1: 'Supercharge Your Memory and ',
    title2: 'Mental Sharpness',
    subtitle: 'Cognition Support',
    section: `Your brain is your most valuable asset—powering your creativity, focus, and daily performance. If you’re feeling mentally foggy or aren’t recalling things as quickly as you used to, Think Factor could be just what you need to reclaim your cognitive edge.*`,
    img1: thinkfactorOverviewBackground,
    img2: antioxidantsBottle,
    imageProps: {
      objpostop: true,
      objectFit: 'cover',
      objectPosition: 'left 25px bottom 65px',
    },
    icon: <GROUP_FOCUS_DARK />,
  },
  ACB: {
    title1: 'Experience the Power of ',
    title2: 'Antioxidant Synergy ',
    title3: '—Naturally!',
    subtitle: 'Vitamin C with Antioxidant Boosters',
    section: `Are you looking for a reliable, convenient way to protect your cells from everyday stress, support healthy aging, and boost your immune response? Antioxidants with Vitamin C and Bioflavonoids is here to help you take charge of your well-being—one capsule at a time.`,
    img1: antioxidantOverviewBackground,
    img2: antioxidantsBottle,
    imageProps: {
      // objpostop: true,
    },
    icon: <VECTOR_IMMUNE_DARK />,
  },
  FSE: {
    title1: 'Reclaim Your',
    title2: 'Radiance and Vitality',
    subtitle: 'Spectrum E Vitamins',
    section: `Support healthy skin, maintain vibrant energy, or bolster your antioxidant defenses like never before. Full Spectrum E is here to help you do all this better, faster, and more effectively. Our unique blend brings together Vitamin E, Vitamin A, Selenium, and natural carotenoids in one convenient capsule—designed to give you a more complete and powerful nutritional boost.`,
    img1: fullSpectrumOverviewBackground,
    img2: fullSpectrumBottle,
    icon: <VECTOR_IMMUNE_DARK />,
  },
  IMF: {
    title1: 'Your Daily',
    title2: 'Immune Guardian',
    subtitle: 'Immune Support',
    section: `Immune Factors is more than just another immune supplement. With its potent blend of standardized, research-backed extracts— including Echinacea, Andrographis, Berberine, and Astragalus— it’s crafted for individuals seeking a robust immune response year-round.`,
    img1: immuneOverviewBackground,
    img2: immuneOverviewBottle,
    icon: <VECTOR_IMMUNE_DARK />,
  },
  NAC: {
    title1: 'The Daily Detox &',
    title2: 'Immune-Support Secret',
    title3: 'You’ve Been Missing',
    subtitle: 'Immune Support',
    section: `Bolster your body’s defense systems and avoid feeling tired, sluggish and run-down. Most people don’t realize how much daily life—exposure to environmental toxins, processed foods, and stress—can deplete our body’s natural defense systems. NAC (N-Acetyl L-Cysteine)  is a nutrient powerhouse that helps clear the path to better overall wellness—naturally.`,
    img1: nAcetyleOverviewBackground,
    img2: nacBottle,
    imageProps: {
      objpostop: true,
      objectFit: 'cover',
      objectPosition: 'left 25px bottom 65px',
    },
    icon: <VECTOR_IMMUNE_DARK />,
  },
  BER: {
    title1: 'Unlock',
    title2: 'Energy and Metabolism',
    title3: '—Naturally!',
    subtitle: 'Blood Sugar Support',
    section: `Support metabolic health, balanced blood sugar, and overall vitality! Berberine has been traditionally celebrated for helping support healthy blood sugar levels, promoting metabolism, and aiding overall well-being. Our formula starts with a potent extract to deliver consistent quality you can trust.`,
    imageProps: {
      objpostop: true,
      objectFit: 'cover',
      objectPosition: 'bottom 65px right 0',
    },
    img1: berberineOverviewBackground,
    img2: berberineBottle,
    icon: <CARDIAC_DARK />,
  },
  VBC: {
    title1: 'Feel More Energized ',
    title2: 'Every Day',
    subtitle: 'Energy',
    section: `When you’re running low on energy, mental clarity, or overall vitality, it’s hard to keep up with life’s demands. Vitamin B Complex is here to help you power through each day—naturally. Discover how our high-potency formula supports better energy levels, stress management, and overall well-being.`,
    img1: vitBOverviewBackground,
    img2: vitaminBComplexBottle,
    imageProps: {
      objpostop: true,
      objectFit: 'cover',
      objectPosition: 'bottom 65px right 0',
    },
    icon: <LIGHTING_BOLT />,
  },
  RYR: {
    title1: 'A Natural Way to Support Heart Health',
    title2: '',
    subtitle: 'Heart Health',
    section: `Are you looking for a safe, time-tested way to help maintain healthy cholesterol levels and support your overall cardiovascular wellness? Our Red Yeast Rice with CoQ10 delivers potent targeted nutrients—without breaking your budget. Help your body achieve healthy cholesterol levels within the normal range.`,
    img1: redYeastOverviewBackground,
    img2: redYeastRiceBottle,
    imageProps: {
      objpostop: true,
      objectFit: 'cover',
      objectPosition: 'left 5px bottom 20px',
    },
    icon: <CARDIAC_DARK />,
  },
  VEP: {
    title1: 'Protect Your Heart and ',
    title2: 'Energize Your Day',
    subtitle: 'Heart Health',
    section: `We all want to maintain a healthy heart, energy levels, and overall wellness Vessel Protection is here to help—an advanced, bioactive B-vitamin supplement designed to give your cardiovascular system the targeted support it needs, while boosting your daily vitality.`,
    img1: vesselProtectOverviewBackground,
    img2: vesselProtectionBottle,
    imageProps: {
      objpostop: true,
      objectFit: 'cover',
      objectPosition: 'bottom 65px left 15px',
    },
    icon: <VECTOR_IMMUNE_DARK />,
  },
  DK2: {
    title1: 'Amplify Your Health',
    title2: 'Every Day',
    subtitle: 'Heart Health',
    section: `Feeling rundown—or worried you’re not giving your bones, heart, and immune system the support they need? Vitamin D3 & K2 combines two essential nutrients that work together to help your body function at its best.`,
    img1: vitDK2OverviewBackground,
    img2: vitaminD3K22000Bottle,
    imageProps: {
      objpostop: true,
      objectFit: 'cover',
      objectPosition: 'bottom 65px right 0',
    },
    icon: <CARDIAC_DARK />,
  },
  DK5: {
    title1: 'Amplify Your Health',
    title2: 'Every Day',
    subtitle: 'Heart Health',
    section: `Feeling rundown—or worried you’re not giving your bones, heart, and immune system the support they need? Vitamin D3 & K2 combines two essential nutrients that work together to help your body function at its best.`,
    img1: vitDK5OverviewBackground,
    img2: vitaminD3K25000Bottle,
    imageProps: {
      objpostop: true,
      objectFit: 'cover',
      objectPosition: 'bottom 65px right 30px',
    },
    icon: <CARDIAC_DARK />,
  },
};
